import { render, staticRenderFns } from "./ProducerPlugin.vue?vue&type=template&id=0240820d&scoped=true&"
import script from "./ProducerPlugin.vue?vue&type=script&lang=js&"
export * from "./ProducerPlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0240820d",
  null
  
)

export default component.exports